app.service('payuPriceLimitMessage', function (orderConfig, modal) {
	var config;

	function checkStatus() {
		if (config.payuPriceLimitMessage) {
			open();
			return true;
		}
		return false;
	}

	function open(message) {
		const contentMessage = message ? message : config.payuPriceLimitMessage;
		modal.generate({
			id: 'modal-payu-price-limit-message',
			closeOnEscape: false,
			close: false,
			content: contentMessage,
			buttons: [
				{
					text: 'Wybieram inny termin dostawy',
					cssClass: 'confirm-button',
					click: function () {
						modal.close();
					}
				}, {
					text: 'Wróć do wyboru płatności',
					cssClass: 'back-button',
					click: function () {
						modal.close();
						$('.js-delivery-time-back').click();
					}
				}
			]
		});
	}

	function init() {
		config = orderConfig.getData();

		if (config.payuPriceLimitMessage) {
			open();
		}
	}

	return {
		init,
		open,
		checkStatus,
	};
});
